import { Config as FinalFormConfig } from 'final-form';
import { FC } from 'react';
import { Form, FormRenderProps } from 'react-final-form';

import RedeemCoupon from '../RedeemCoupon';

export type RedeemCouponFormFields = {
  coupon: string;
};

export type RedeemCouponFormProps = { placeholder?: string };

const renderForm = ({ placeholder }: RedeemCouponFormProps) => ({
  handleSubmit
}: FormRenderProps<RedeemCouponFormFields>) => (
  <form>
    <RedeemCoupon placeholder={placeholder} onRedeem={handleSubmit} />
  </form>
);

const RedeemCouponForm: FC<FinalFormConfig & RedeemCouponFormProps> = props => (
  <Form render={renderForm(props)} {...props} />
);

export default RedeemCouponForm;
